import { useEffect, useState } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';

import AdvancedRecordTable from '../../components/Tables/advancedRecord/AdvancedRecordTable';
import { useReceivableTable } from '../../modules/receivable/table/hooks/useReceivableTable';
import { receivableTableColumns } from '../../modules/receivable/table/config/receivableTableColumns';
import { getReceivableFilters } from '../../modules/receivable/table/config/receivableTableFilters';
import { useCustomer } from '../../hooks/useCustomer';
import { getReceivableTableActions } from '../../modules/receivable/types/receivableTableActions';
import { ReceivableFilter } from '../../modules/receivable/types/receivableFilter.types';
import { useNavigate } from 'react-router-dom';
import ReceivableDetailModal from '../../modules/receivable/detail/components/ReceivableDetailModal';
import { useReceivableDetail } from '../../modules/receivable/detail/hooks/useReceivableDetail';
import { useSale } from '../../hooks/sale/useSale';
import SaleViewModal from '../Sale/history/SaleViewModal';

const ClientBalancesPage = () => {
  const { saleToViewLoaded, handleCloseViewModal } =
      useSale();
  
  const { list, paginator, size, fetchReceivables, changeSize } =
    useReceivableTable();

  const { isModalOpen, handleOpenDetailModal, handleCloseDetailModal } =
    useReceivableDetail();

  const baseFilter: ReceivableFilter = {
    statuses: ['PENDING', 'PARTIAL'],
    overdue: false,
  };

  const [filters, setFilters] = useState<ReceivableFilter>(baseFilter);
  const navigate = useNavigate();
  const { handlerGetCustomersForDropdown, customersDropdown } = useCustomer();

  // 🔍 filtros
  const handleFilterChange = (newFilters: ReceivableFilter) => {
    const merged = {
      ...baseFilter,
      ...newFilters,
    };

    setFilters(merged);
    fetchReceivables(merged, 0);
  };

  // 🔄 reset correcto
  const handleResetFilters = () => {
    setFilters(baseFilter);
    fetchReceivables(baseFilter, 0);
  };

  // 📄 paginación
  const handlePageChange = (page: number) => {
    fetchReceivables(filters, page);
  };

  const handlePageSizeChange = (size: number) => {
    changeSize(size, filters);
  };

  useEffect(() => {
    fetchReceivables(baseFilter);
    handlerGetCustomersForDropdown();
  }, []);

  const filterFields = getReceivableFilters(customersDropdown);

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <AdvancedRecordTable
        columns={receivableTableColumns}
        data={list}
        paginator={paginator}
        pageSize={size}
        filtersConfig={filterFields}
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        url="/client-balances"
        noDataMessage="No hay cuentas por cobrar."
        getActions={(row) =>
          getReceivableTableActions({
            row,
            handlers: {
              onView: (id) => {
                handleOpenDetailModal(id);
              },
              onPay: (id) => navigate(`/finance/cxc/register-payment/${id}`),
              onHistory: (id) => navigate(`/finance/cxc/payment-history/${id}`),
            },
          })
        }
      />

      <ReceivableDetailModal
        isOpen={isModalOpen}
        onClose={handleCloseDetailModal}
      />

      <SaleViewModal isOpen={saleToViewLoaded} onClose={handleCloseViewModal} />
    </DefaultLayout>
  );
};

export default ClientBalancesPage;
